export function setTimeoutInHook(...args: Parameters<typeof setTimeout>) {
  // eslint-disable-next-line @typescript-eslint/no-implied-eval
  const timeout = setTimeout(...args);
  return () => clearTimeout(timeout);
}
